/** Fallback image when a product/catalog image fails to load */
export const STORE_MISSING_IMAGE_URL =
  "/store/missing-image.png";

export const CARPENTER_ROOMS = [
  "Kitchen",
  "Living Room",
  "Bedroom 1",
  "Bedroom 2",
  "Bedroom 3",
  "Bedroom 4",
  "Master Bedroom",
  "Guest Bedroom",
  "Foyer",
  "Balcony",
  "Pooja",
  "Other Room 1",
  "Other Room 2",
  "Other Room 3",
];

export const CARPENTER_GROUPS = [
  "Wall A",
  "Wall B",
  "Wall C",
  "Wall D",
  "Wall E",
  "Wall F",
];

export const UI_RESTRICTED_PROPERTIES = [
  "fabrication",
  "pre_drilling",
  "grooves",
  "assembly",
  "expo_minifix",
  "handle",
  "shutter",
  "internal_drawer_handle",
];

export const PROPERTIES_TO_HIDE = [
  "Predrilling",
  "Carcass Grooves",
  "Module Assembly",
  "Minifix for Exposed Cabinet",
  "Fabrication Quality",
];

export const EXPO_COLOR_PROPERTIES = [
  "left_expo_color",
  "right_expo_color",
  "top_expo_color",
  "bottom_expo_color",
  "back_expo_color",
];

export const EDGE_COLOR_PROPERTIES = [
  "partition_front_edge_color",
  "carcass_front_edge_color",
];

export const LAM_CATEGORIES = [
  "lam_1",
  "lam_350_400",
  "lam_400_450",
  "lam_450_500",
  "lam_500_550",
  "lam_550_600",
  "lam_600_650",
  "lam_650_700",
  "lam_700_750",
  "lam_750_1000",
  "lam_1000_1250",
  "lam_1250_1500",
  "lam_1500_1750",
  "lam_1750_2000",
  "lam_2000_2250",
  "lam_2250_2500",
  "lam_2500_2750",
  "lam_2750_3000",
  "lam_3000_3250",
  "lam_3250_3500",
  "lam_3500_3750",
  "lam_3750_4000",
  "lam_4000_4250",
  "lam_4250_4500",
  "lam_4500_4750",
  "lam_4750_5000",
  "lam_5000_5250",
  "lam_5250_5500",
  "lam_5500_6500",
  "lam_6500_7500",
  "lam_7500_8500",
];

export const LAM_BRANDS = [
  "Acemica",
  "Acrosheen",
  "Acrylam",
  "Advance",
  "Aerolite",
  "Aica",
  "Airolam",
  "Alco",
  "Archidlam",
  "Artistry",
  "Axilam",
  "Belador",
  "Berga",
  "Brand",
  "Bravia",
  "Catch",
  "Century",
  "Ciscon",
  "Crystaline",
  "Delta",
  "Dexarte",
  "Dixon",
  "Dorby",
  "Durian",
  "Encode",
  "Europratik",
  "Finetouch",
  "Flexibond",
  "Fushion",
  "Fusion",
  "Genoa",
  "Gloirio",
  "Greenlam",
  "Heritage",
  "Hilaxe",
  "I-lam",
  "Italam",
  "Ivas",
  "Keshari",
  "Manilam",
  "Matchlam",
  "Meraki",
  "Merino",
  "Merru",
  "Newmika",
  "Nisac",
  "Ogaan",
  "Pebble",
  "Promica",
  "Rehau",
  "Reolaxe",
  "Rgb",
  "Rotolam",
  "Royal Crown",
  "Royale Touche",
  "SK",
  "SK2",
  "Safari",
  "Safedecor",
  "Sapphire",
  "Sequence",
  "Shd",
  "Signature",
  "Skydecors",
  "Star",
  "Star Mica",
  "Stylam",
  "Sundek",
  "Sunmica",
  "Swedish",
  "Timex",
  "Toughline",
  "Treelam",
  "Urban",
  "Vibron",
  "Vir",
  "Virgo",
  "Virgolam",
  "Virlam",
  "Wolaxe",
  "Zak",
  "Zurich",
];

export const LAM_THICKNESSES = [0.6, 0.7, 0.8, 1, 1.25, 1.5, 2, 2.5, 3, 3.5, 4];

export const BASE_TYPES = [
  {
    type: "shell",
    addonsType: [
      "only_carcass",
      "shell_variant",
      "internal_color",
      "shutter_colors",
      "external_color",
      "carcass_material",
      "shutter_material",
      "hinge",
      "plinth",
      "expo",
      "expo_material",
      "minifix",
      "cnc",
      "pattern",
      "handle_type",
      "g_profile_finish",
      "j_profile_finish",
      "gola_profile_floor_finish",
      "gola_profile_wall_finish",
      "carcass_front_edge_color",
      "backsheet_build_technique",
      "drawer_mechanism",
      "shutter_type",
      "build_type",
      "carcass_thickness",
      "front_offset",
      "partition_front_edge_thickness",
      "front_edge_thickness",
      "shutter_thickness",
      "shutter_edge_thickness",
      "open_carcass_backsheet_type",
      "sliding_shutter_mechanism",
      "skirting_height",
      "frame_depth",
      "frame_carcass_type",
      "back_expo_color",
      "left_expo_color",
      "right_expo_color",
      "top_expo_color",
      "bottom_expo_color",
      "partition_front_edge_color",
      "profile_type",
      "profile_handle_type",
      "profile_color",
      "profile_glass_type",
      "profile_handle_position",
      "drawer_mechanism_type",
      "sliding_shutter_mechanism_3_door",
      "sliding_shutter_mechanism_2_door",
    ],
  },
  {
    type: "regular_drawers",
    addonsType: [
      "internal_color",
      "carcass_material",
      "shutter_material",
      "drawer_channel",
    ],
  },
  {
    type: "wide_drawers",
    addonsType: [
      "internal_color",
      "carcass_material",
      "shutter_material",
      "drawer_channel",
    ],
  },
  {
    type: "shelves",
    addonsType: [
      "internal_color",
      "shutter_colors",
      "external_color",
      "carcass_material",
      "shutter_material",
    ],
  },
];

export const HINGE_NAMES = {
  ebco_normal_close: "Ebco NC",
  ebco_soft_close: "Ebco SC",
  hettich_onsys_normal_close: "Hettich Onsys NC",
  hettich_onsys_soft_close: "Hettich Onsys SC",
  hafele_normal_close: "Hafele NC",
  hafele_soft_close: "Hafele SC",
  hepo_normal_close: "Hepo NC",
  hepo_soft_close: "Hepo SC",
  blum_soft_close: "Blum Cliptop SC",
  ebco_soft_close_ss: "Ebco SS304 Soft Close",
  hettich_veosys_soft_close_ss: "Hettich Veosys SS304 Soft Close",
  moda_soft_close: "Moda Soft Close",
};

export const DRAWER_NAMES = {
  ebco_normal_close_telescopic: "Ebco STDS NC 35",
  ebco_soft_close_telescopic: "Ebco STDS SC 35",
  ebco_soft_close_quadro: "Ebco CDSS SC 30",
  ebco_soft_close_tandem: "Ebco PMDS3 SC 50",
  hettich_onsys_normal_close_telescopic: "Hettich KA5632 NC 35",
  hettich_onsys_soft_close_telescopic: "Hettich KA4732 SC 35",
  hettich_onsys_soft_close_quadro: "Hettich V6 UM SC 30",
  hettich_onsys_soft_close_tandem: "Hettich INNOTECH TB SC 30",
  hafele_normal_close_telescopic: "Hafele NC 30",
  hafele_soft_close_telescopic: "Hafele SC 30",
  hafele_soft_close_quadro: "Hafele Matrix UM SC 35",
  hafele_soft_close_tandem: "Hafele Matrixbox Premium SC 40",
  hepo_normal_close_telescopic: "Hepo NC 35",
  hepo_soft_close_telescopic: "Hepo SC 35",
  hepo_soft_close_quadro: "Hepo UM SC 30",
  hepo_soft_close_tandem: "Hepo Classicbox SC 35",
  moda_soft_close_telescopic: "Moda MTS-SC-4512-Zinc",
  moda_soft_close_slimbox_tandem: "Moda Magic Box Tandem",
  grass_nova_pro_scala_tandem: "Grass Nova Pro Scala Tandem",
};

export const HANDLE_NAMES = {
  external_handle: "No Handle",
  g_profile: "G Profile",
  j_profile: "J Profile",
  gola_profile_floor: "Gola",
  gola_profile_wall: "Wall Gola",
  push_open: "Push Open",
  finger_groove: "Finger Groove",
};

export const SLIDING_MECHANISM_NAMES = {
  hettich_sl16: "Hettich SL16",
  ebco_hi_slide_50_reversible: "Ebco Hi-Slide 50 REVERSIBLE",
  ebco_hi_slide_45: "Ebco HI-Slide 45",
  ebco_hi_slide_50_reversible_concealed:
    "Ebco Hi-Slide 50 Reversible Concealed",
};

export const EDGE_THICKNESS_NAMES = {
  0.5: "",
  2: "2mm front",
};
